import React from "react";

import { connect } from "react-redux";

import JobLiveGridViewCard from "./JobLiveGridViewCard";
import GridListView from "../../../common/GridListView";
import { selectFlattenPostData } from "../../../redux/slices/postsSlice";

const JobLiveGridView = ({ posts, onScrollEndReach }) => {
  console.log("🚀 JobLiveGridView Component:");

  return (
    <GridListView
      data={["create-job-button", ...posts]}
      emptyTxt="Looks like there's no jobs found. Try adjusting your filters"
      useImg2={false}
      containerStyle={{ height: "82%" }}
      onLoadMore={onScrollEndReach}
      itemGridStyles={{ md: 3, xs: 12 }}
      renderItem={(index, id) => (
        <JobLiveGridViewCard index={index} key={id} id={id} />
      )}
    />
  );
};

const mapStateToProps = (state) => ({
  posts: selectFlattenPostData(state),
});

export default connect(mapStateToProps)(JobLiveGridView);
